const FACET_REFERENCE_FACET_LABEL_DEPARTMENT = 'facet_reference.facet_label_department';
const FACET_REFERENCE_FACET_LABEL_STYLE = 'facet_reference.facet_label_style';
const FACET_REFERENCE_FACET_LABEL_COLOR = 'facet_reference.facet_label_color';
const FACET_REFERENCE_FACET_LABEL_PRICE = 'facet_reference.facet_label_price';
const FACET_REFERENCE_FACET_LABEL_SIZE = 'facet_reference.facet_label_size';
const FACET_REFERENCE_FACET_LABEL_RATING = 'facet_reference.facet_label_rating';

export {
  FACET_REFERENCE_FACET_LABEL_DEPARTMENT,
  FACET_REFERENCE_FACET_LABEL_STYLE,
  FACET_REFERENCE_FACET_LABEL_COLOR,
  FACET_REFERENCE_FACET_LABEL_PRICE,
  FACET_REFERENCE_FACET_LABEL_SIZE,
  FACET_REFERENCE_FACET_LABEL_RATING,
};
